import React from 'react';

import { PageSidebar, PageTitle, SidebarHeading } from '../../../components';

import { FaCircleNotch, FaPrint } from 'react-icons/fa';

import { Link, useLocation } from 'react-router-dom';
import { positions } from '../../../constants';



const CareerSingle = () => {

  // Get the current location state
  const location = useLocation();  
  const positionSingle = location.state; 

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={positionSingle.title} page={"Position Single"} />

      <section className='position-single page-single'>

        <div className='position-info page-info'>

          {/* Job Image Section */} 
          <div className='image'>
            <img src={positionSingle.image} alt={positionSingle.title} />
          </div>

          <div className='content'>

            {/* Sidebar Section */}
            <PageSidebar
              heading={'Position'}
              details={positionSingle.details}
              button={{ link: 'Career-Form', title: 'Apply Now' }}
            />

            {/* Job Title */}
            <h3 className='main-heading'>{positionSingle.title}</h3>

            {/* Job Description Section */}
            {positionSingle.overviews.map((overview, index) => (
              <p key={index}>{overview}</p>
            ))}

            {/* Job Responsibilities Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Job Responsibilities:</h3>
              <p>As a {positionSingle.title}, your responsibilities will include:</p>

              {/* List of Responsibilities */}
              <ul>
                {positionSingle.responsibilities.map((responsibility, index) => (
                  <li key={index}>
                    <div className='icon'><FaCircleNotch /></div>
                    {responsibility}
                  </li>
                ))}
              </ul>
            </div>

            {/* Qualifications & Skills Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Qualifications & Skills</h3>
              <p>To succeed in this role, you'll need:</p>

              {/* List of Qualifications */}
              <ul>
                {positionSingle.qualifications.map((qualification, index) => (
                  <li key={index}>
                    <div className='icon'><FaCircleNotch /></div>
                    {qualification}
                  </li>
                ))}
              </ul>
            </div>

          </div> 
        </div> 

        <div className='sidebar service-sidebar'>

          <div className='category sidebar-item'>

            <SidebarHeading title={'all Positions'} />

            <div className='box-container'>
              {positions.map(position => {
                return  (
                /* Link to the individual service page */
                <Link
                  to={{
                    pathname: '/Careers/' + position.title,
                  }}
                  location = {{position}}
                  state= {position}
                  key={position.id}
                  className='item'><span><div className='icon'><FaPrint /></div>{position.title}</span> {/* Position Title */}
                </Link> )
              })}
            </div>

          </div>

        </div>

      </section>
    </> 
  );
}

export default CareerSingle;